import { WEBHOOK_EVENT_TYPES } from '../webhook-event-types.js';
import { getUserAndEventTime } from './lib/index.js';
export const createEmployerDocumentsFetchedSamplePayload = () => {
    return {
        eventType: WEBHOOK_EVENT_TYPES.EMPLOYER_DOCUMENTS_FETCHED,
        ...getUserAndEventTime(),
        data: {
            uri: 'https://api.atomicfi.com/employers/5d77f95207085632a58945c3/employer-documents',
            employerId: '642c9aa6f8fc90e0dbb4c92f',
            validationErrors: [
                {
                    instancePath: '/date',
                    schemaPath: '#/properties/date/type',
                    keyword: 'type',
                    params: {
                        type: 'object'
                    },
                    message: 'must be object',
                    value: '2023-09-30',
                    data: {
                        file: '652d6728647a0ec56495b5a3',
                        date: '2023-09-30',
                        type: '941'
                    }
                }
            ]
        }
    };
};
//# sourceMappingURL=employer-documents-fetched.js.map